import { getAuthHeaders, tempMeeApi } from '~/services/api';
import type {
  ISaveOfficeWorkerClassificationApiResponse,
  ISaveWorkerClassificationApiPayload,
} from '../types/SaveWorkerType.api';

/**
 * Sets one location's worker type on behalf of the signed-in account. The
 * location is in the path, and the request drops the selected office's `x-office`
 * so the author is the token's own account, an ancestor of every location it can
 * open: a sibling selected in the header is not the location's ancestor and would
 * be refused (unlike `saveWorkerClassification`, which writes the selected office).
 */
export const saveOfficeWorkerClassification = async (
  officeId: string,
  payload: ISaveWorkerClassificationApiPayload,
): Promise<ISaveOfficeWorkerClassificationApiResponse> => {
  const headers = await getAuthHeaders();
  const { data } = await tempMeeApi.patch<ISaveOfficeWorkerClassificationApiResponse>(
    `/users/${officeId}/worker-classification`,
    payload,
    { headers: { ...headers, 'x-office': undefined } },
  );
  return data;
};
